import React, { ComponentProps, FC } from 'react';

import { Box, Container, Icon, IconButton, Text } from '@rbilabs/universal-components';

import LoadingAnimation from 'components/loading-animation';
import { useIdCounter } from 'hooks/use-id-counter';
import { theme } from 'styles/configure-theme';
import noop from 'utils/noop';

interface IStoreActionsButtonProps {
  disabled?: boolean;
  icon: ComponentProps<typeof Icon>['variant'];
  loading?: boolean;
  onPress?: () => void;
  text: string;
}

export const StoreActionsButton: FC<IStoreActionsButtonProps> = ({
  disabled = false,
  onPress = noop,
  icon,
  text,
  loading = false,
}) => {
  const storeActionButtonId = useIdCounter('store-action-button');

  return (
    <Container testID="store-action-button-container" alignItems="center" marginY={0} marginX={4}>
      {loading ? (
        <Box
          size="$13.5"
          justifyContent="center"
          alignContent="center"
          borderRadius="full"
          position="relative"
          bg={theme.token('background-button-primary-default')}
        >
          <LoadingAnimation size="sm" reversed />
        </Box>
      ) : (
        <IconButton
          variant="unstyled"
          testID="store-action-button"
          accessibilityLabel={text}
          isDisabled={loading || disabled}
          id={storeActionButtonId}
          onPress={onPress}
          backgroundColor={
            loading || disabled
              ? theme.token('background-checkbox-disabled')
              : theme.token('background-button-primary-default')
          }
          borderRadius="full"
          position="relative"
          boxSize="$13.5"
          alignItems="center"
          justifyContent="center"
          hitSlop={10}
          icon={
            <Icon
              variant={icon}
              color={disabled ? theme.token('text-disabled') : theme.token('icon-button-primary')}
              size="8"
            />
          }
          _web={{
            _hover: {
              cursor: 'pointer',
              backgroundColor: theme.token('background-button-primary-hover'),
            },
          }}
          _pressed={{
            backgroundColor: theme.token('background-button-primary-hover'),
            style: {
              transform: [{ scale: 0.95 }],
            },
          }}
        />
      )}

      <Text
        fontFamily="heading"
        testID="store-action-text"
        color={loading || disabled ? theme.token('text-disabled') : theme.token('text-default')}
        marginTop="$1"
        marginBottom="$2"
        fontSize="md"
      >
        {text}
      </Text>
    </Container>
  );
};
